import React from 'react'
import { useNavigate } from 'react-router-dom'
import Button from '../../../Elements/Button/Button'

const RegistrarEmpresaHome = () => {
  const navigate = useNavigate()

  return (
    <div className="container mt-4">
      <div className="row justify-content-center">
        <div className="col-12 col-md-6">
          <h2 className="mb-4">Gestión de empresas</h2>
          <div className="d-flex flex-column gap-3">
            <Button
              text="Registrar empresa"
              color="green"
              fill
              action={() => navigate('/registrarEmpresa')}
            />
            <Button
              text="Ver registros"
              color="blue"
              action={() => navigate('/ver-registros')}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default RegistrarEmpresaHome